import { render, staticRenderFns } from "./address-index.vue?vue&type=template&id=eccde6a0&scoped=true&"
import script from "./address-index.vue?vue&type=script&lang=js&"
export * from "./address-index.vue?vue&type=script&lang=js&"
import style0 from "./address-index.vue?vue&type=style&index=0&id=eccde6a0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccde6a0",
  null
  
)

export default component.exports